/* ============================================================
   WYR - Our Fabric (Datasheet) - ported from Claude Design
   "fabric/interactions.js". Vanilla, no dependencies.
   Boots once across all .wyr-fabric sections on the page.
   ============================================================ */
(function () {
  if (window.WYRFabric && window.WYRFabric.__booted) return;
  var WYR = window.WYRFabric = window.WYRFabric || {};

  function anyNoAnim() { return !!document.querySelector('.wyr-fabric.no-anim'); }
  function elNoAnim(el) { var w = el.closest('.wyr-fabric'); return !!(w && w.classList.contains('no-anim')); }

  /* ---------------------------------------------------------
     1. Scroll reveals
  --------------------------------------------------------- */
  WYR.initReveals = function () {
    var els = [].slice.call(document.querySelectorAll('.wyr-fabric .reveal'));
    if (!els.length) return;

    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || anyNoAnim() || !('IntersectionObserver' in window) || vh < 200) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var el = e.target;
          var d = el.dataset.delay ? parseInt(el.dataset.delay, 10) : 0;
          setTimeout(function () { el.classList.add('in'); }, d);
          io.unobserve(el);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top > vh * 0.9) { el.classList.add('pre'); io.observe(el); }
    });

    // Safety net: force any still-hidden element visible if the observer never fires.
    setTimeout(function () {
      document.querySelectorAll('.wyr-fabric .reveal.pre:not(.in)').forEach(function (el) { el.classList.add('in'); });
    }, 2200);
  };

  /* ---------------------------------------------------------
     2. Animated counters  - elements with [data-count]
  --------------------------------------------------------- */
  function animateCount(el) {
    var target = parseFloat(el.dataset.count);
    var dec = parseInt(el.dataset.dec || '0', 10);
    var prefix = el.dataset.prefix || '';
    var suffix = el.dataset.suffix || '';
    var dur = parseInt(el.dataset.dur || '1400', 10);
    if (elNoAnim(el)) { el.textContent = prefix + target.toFixed(dec) + suffix; return; }
    var t0 = performance.now();
    function frame(now) {
      var p = Math.min(1, (now - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3); // easeOutCubic
      var v = target * e;
      el.textContent = prefix + v.toFixed(dec) + suffix;
      if (p < 1) requestAnimationFrame(frame);
      else el.textContent = prefix + target.toFixed(dec) + suffix;
    }
    requestAnimationFrame(frame);
  }
  WYR.initCounters = function () {
    var els = [].slice.call(document.querySelectorAll('.wyr-fabric [data-count]'));
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(animateCount); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animateCount(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  };

  /* ---------------------------------------------------------
     3. Fiber-length visualization (canvas)
  --------------------------------------------------------- */
  WYR.initFiberViz = function (rootEl) {
    if (!rootEl) return;
    var canvas = rootEl.querySelector('canvas[data-fiber]');
    var range = rootEl.querySelector('input[data-fiber-range]');
    if (!canvas || !range) return;
    var ctx = canvas.getContext('2d');
    var outs = {};
    rootEl.querySelectorAll('[data-out]').forEach(function (o) { outs[o.dataset.out] = o; });
    var pillBar = rootEl.querySelector('[data-meter="pill"] > i');
    var strBar = rootEl.querySelector('[data-meter="strength"] > i');

    var wrap = rootEl.closest('.wyr-fabric') || document.documentElement;
    var cs = getComputedStyle(wrap);
    var inkC = cs.getPropertyValue('--ink').trim() || '#1a1a17';
    var rustC = cs.getPropertyValue('--rust').trim() || '#9c5a3c';
    var mutedC = cs.getPropertyValue('--muted').trim() || '#76705f';

    var DPR = Math.min(2, window.devicePixelRatio || 1);
    function resize() {
      var r = canvas.getBoundingClientRect();
      canvas.width = r.width * DPR; canvas.height = r.height * DPR;
    }

    // deterministic pseudo-random so redraw is stable per length
    function rng(seed) {
      var s = seed % 2147483647; if (s <= 0) s += 2147483646;
      return function () { return (s = s * 16807 % 2147483647) / 2147483647; };
    }

    // A SINGLE thread of spun cotton. Long staple => smooth, few ends.
    // Short staple => stubby fibres, frayed ends, pills.
    function draw(mm) {
      resize();
      var W = canvas.width, H = canvas.height;
      ctx.clearRect(0, 0, W, H);
      var q = Math.max(0, Math.min(1, (mm - 18) / (40 - 18)));  // 1 = long staple
      var risk = 1 - q;
      var midY = H / 2;
      var threadR = 17 * DPR;
      var segPx = (mm / 27) * 145 * DPR;
      ctx.lineCap = 'round';

      var sh = ctx.createLinearGradient(0, midY, 0, midY + threadR * 2.2);
      sh.addColorStop(0, 'rgba(26,26,23,0.10)');
      sh.addColorStop(1, 'rgba(26,26,23,0)');
      ctx.fillStyle = sh;
      ctx.fillRect(0, midY, W, threadR * 2.2);

      var body = ctx.createLinearGradient(0, midY - threadR, 0, midY + threadR);
      body.addColorStop(0, 'rgba(96,86,66,0.10)');
      body.addColorStop(0.5, 'rgba(150,136,110,0.26)');
      body.addColorStop(1, 'rgba(96,86,66,0.10)');
      ctx.fillStyle = body;
      ctx.fillRect(0, midY - threadR * 1.15, W, threadR * 2.3);

      var wave = function (x) { return midY + Math.sin(x * 0.012 + 2) * 4 * DPR; };

      var rows = 34;
      var endProb = 0.006 + risk * risk * 0.9;
      var twistAmp = threadR * (0.06 + risk * 0.6);
      var phaseOff = 0.12 + risk * 0.7;
      var noiseAmp = (0.08 + risk * 2.0) * DPR;
      for (var r = 0; r < rows; r++) {
        var rand = rng((Math.round(mm * 10) + 5) * (r + 7) * 89);
        var off = (r / (rows - 1) - 0.5) * 2;
        var yBand = off * threadR;
        var light = (62 + rand() * (8 + risk * 22));
        var alpha = 0.4 + rand() * (0.3 + risk * 0.2);
        ctx.strokeStyle = 'hsla(34,24%,' + light + '%,' + alpha + ')';
        ctx.lineWidth = (1.0 + rand() * 0.7) * DPR;
        var x = -rand() * segPx;
        while (x < W + segPx) {
          var len = segPx * (0.88 + rand() * 0.24);
          var twist = 30 * DPR;
          ctx.beginPath();
          var steps = 14;
          for (var i = 0; i <= steps; i++) {
            var xx = x + len * (i / steps);
            var phase = (xx / twist) + r * phaseOff;
            var yy = wave(xx) + yBand * (0.72 + 0.28 * q)
              + Math.sin(phase) * twistAmp * (0.5 + Math.abs(off))
              + Math.sin(xx * 0.08 + r) * noiseAmp;
            if (i === 0) ctx.moveTo(xx, yy); else ctx.lineTo(xx, yy);
          }
          ctx.stroke();

          var endX = x + len;
          if (endX > 2 && endX < W - 2 && rand() < endProb) {
            var dir = (off >= 0 ? 1 : -1) * (rand() > 0.3 ? 1 : -1);
            var fl = (5 + risk * 24) * DPR;
            var ey = wave(endX) + yBand;
            ctx.beginPath();
            ctx.strokeStyle = risk > 0.42
              ? 'hsla(22,46%,54%,' + (0.45 + 0.4 * risk) + ')'
              : 'hsla(38,18%,70%,0.5)';
            ctx.lineWidth = Math.max(0.6, 0.85 * DPR);
            ctx.moveTo(endX, ey);
            ctx.quadraticCurveTo(
              endX + dir * fl * 0.4, ey + dir * fl * 0.5,
              endX + dir * fl * (0.5 + rand() * 0.7), ey + dir * fl * (0.7 + rand() * 0.7));
            ctx.stroke();
          }
          x += len + segPx * 0.012;
        }
      }

      var sheen = ctx.createLinearGradient(0, midY - threadR, 0, midY + threadR * 0.2);
      sheen.addColorStop(0, 'hsla(46,40%,99%,0)');
      sheen.addColorStop(0.5, 'hsla(46,42%,99%,' + (0.16 + q * 0.5) + ')');
      sheen.addColorStop(1, 'hsla(46,40%,99%,0)');
      ctx.fillStyle = sheen;
      ctx.fillRect(0, midY - threadR, W, threadR * 1.2);
      ctx.strokeStyle = 'hsla(46,42%,99%,' + (0.30 + q * 0.45) + ')';
      ctx.lineWidth = 2.2 * DPR;
      ctx.beginPath();
      for (var x2 = 0; x2 <= W; x2 += 6 * DPR) ctx.lineTo(x2, wave(x2) - threadR * 0.4);
      ctx.stroke();
      ctx.strokeStyle = 'hsla(32,26%,38%,' + (0.20 + q * 0.22) + ')';
      ctx.lineWidth = 1.6 * DPR;
      ctx.beginPath();
      for (var x3 = 0; x3 <= W; x3 += 6 * DPR) ctx.lineTo(x3, wave(x3) + threadR * 0.52);
      ctx.stroke();

      // Pill "bubbles" disabled per Karim 2026-05-29 (read as visual noise on scroll).
      // The frayed loose-ends rendered above still differentiate short vs long staple.
      var pillCount = 0;
      for (var p = 0; p < pillCount; p++) {
        var prand = rng((p * 2 + 13) * 779 + Math.round(mm * 10) * 31);
        var px = W * ((p + 0.5) / pillCount + (prand() - 0.5) * (0.7 / pillCount));
        var py = wave(px) + (prand() - 0.5) * threadR * 1.5;
        var pr = (4.5 + prand() * 4 + risk * 4) * DPR;
        for (var k = 0; k < 14; k++) {
          var a = prand() * 7, l = pr * (1.0 + prand() * 1.3);
          ctx.strokeStyle = 'hsla(28,24%,52%,' + (0.28 + prand() * 0.3) + ')';
          ctx.lineWidth = 0.7 * DPR;
          ctx.beginPath(); ctx.moveTo(px, py);
          ctx.lineTo(px + Math.cos(a) * l, py + Math.sin(a) * l); ctx.stroke();
        }
        ctx.fillStyle = 'rgba(26,26,23,0.18)';
        ctx.beginPath(); ctx.ellipse(px + pr * 0.18, py + pr * 0.85, pr * 0.9, pr * 0.38, 0, 0, 7); ctx.fill();
        var rg = ctx.createRadialGradient(px - pr * 0.32, py - pr * 0.32, 0, px, py, pr);
        rg.addColorStop(0, 'hsla(40,22%,90%,1)');
        rg.addColorStop(0.55, 'hsla(34,20%,78%,0.98)');
        rg.addColorStop(0.85, 'hsla(28,22%,62%,0.92)');
        rg.addColorStop(1, 'hsla(26,24%,50%,0.5)');
        ctx.fillStyle = rg;
        ctx.beginPath(); ctx.arc(px, py, pr, 0, 7); ctx.fill();
        for (var k2 = 0; k2 < 5; k2++) {
          var a2 = prand() * 7;
          ctx.strokeStyle = 'hsla(30,18%,58%,0.4)';
          ctx.lineWidth = 0.6 * DPR;
          ctx.beginPath();
          ctx.arc(px, py, pr * (0.4 + k2 * 0.12), a2, a2 + 1.6 + prand());
          ctx.stroke();
        }
      }
    }

    function update() {
      var mm = parseFloat(range.value);
      var strength = Math.max(14, Math.round(mm * 1.15 - 3.5));
      var sfi = Math.max(3, Math.round(27 - 0.62 * mm));
      var pill = Math.max(2, Math.round((30 - mm) / 30 * 100));
      var washes = Math.round(Math.pow(mm / 14, 4.2) * 3);
      if (outs.mm) outs.mm.textContent = mm.toFixed(0);
      if (outs.strength) outs.strength.textContent = strength;
      if (outs.sfi) outs.sfi.textContent = sfi;
      if (outs.pill) outs.pill.textContent = pill;
      if (outs.washes) outs.washes.textContent = washes;
      if (pillBar) pillBar.style.width = pill + '%';
      if (strBar) strBar.style.width = Math.max(4, Math.min(100, Math.round((strength - 14) / 38 * 100))) + '%';
      var verdict = rootEl.querySelector('[data-out="verdict"]');
      if (verdict) {
        var v = 'Commodity range';
        if (mm >= 32) v = 'Long-staple Giza';
        else if (mm >= 28) v = 'Pima / premium';
        else if (mm < 22) v = 'Short / coarse';
        verdict.textContent = v;
        rootEl.dataset.zone = mm >= 32 ? 'giza' : (mm <= 27 ? 'commodity' : 'mid');
      }
      draw(mm);
    }

    range.addEventListener('input', update);
    window.addEventListener('resize', function () { draw(parseFloat(range.value)); });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        if (elNoAnim(rootEl)) { update(); return; }
        var final = parseFloat(range.value);
        range.value = 18; update();
        var t0 = performance.now();
        function stepFn(now) {
          var p = Math.min(1, (now - t0) / 1100);
          var e2 = 1 - Math.pow(1 - p, 3);
          range.value = (18 + (final - 18) * e2).toFixed(1);
          update();
          if (p < 1) requestAnimationFrame(stepFn);
        }
        requestAnimationFrame(stepFn);
      });
    }, { threshold: 0.4 });
    io.observe(rootEl);
    update();
  };

  /* ---------------------------------------------------------
     4. Comparison table - column focus (click to isolate vs WYR)
  --------------------------------------------------------- */
  WYR.initCompareA = function (table) {
    if (!table) return;
    var cols = [].slice.call(table.querySelectorAll('thead th'));
    var active = null;
    function setActive(idx) {
      if (active === idx) idx = null; // toggle off
      active = idx;
      table.querySelectorAll('th,td').forEach(function (c) { c.classList.remove('focus', 'dim'); });
      if (idx === null) { table.classList.remove('isolating'); return; }
      table.classList.add('isolating');
      table.querySelectorAll('tr').forEach(function (tr) {
        [].slice.call(tr.children).forEach(function (c, i) {
          if (i === 0 || i === 1 || i === idx) c.classList.add('focus');
          else c.classList.add('dim');
        });
      });
    }
    cols.forEach(function (th, i) {
      if (i < 2) return; // skip label col + WYR col
      th.style.cursor = 'pointer';
      th.addEventListener('click', function () { setActive(i); });
    });
  };

  /* ---------------------------------------------------------
     5. Stretch bar - animate on first reveal
  --------------------------------------------------------- */
  WYR.initStretch = function (sb) {
    if (!sb) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('shown'); io.unobserve(e.target); } });
      }, { threshold: 0.4 });
      io.observe(sb);
    }
    setTimeout(function () { sb.classList.add('shown'); }, 1700);
  };

  /* ---------------------------------------------------------
     Boot
  --------------------------------------------------------- */
  function boot() {
    if (WYR.__booted) return;
    WYR.__booted = true;
    WYR.initReveals();
    WYR.initCounters();
    document.querySelectorAll('.wyr-fabric .fiber[data-fiber-viz]').forEach(WYR.initFiberViz);
    document.querySelectorAll('.wyr-fabric table.cmp').forEach(WYR.initCompareA);
    document.querySelectorAll('.wyr-fabric .stretchbar').forEach(WYR.initStretch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when a section is re-rendered in the theme editor.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () { WYR.__booted = false; boot(); });
  }
})();
